import { PalletteProps } from '../../types/theme/pallette';
import styled from 'styled-components';

export const Wrapper = styled.div`
  height: fit-content;
  display: flex;
  flex-direction: column-reverse;
  justify-content: revert;
  align-items: center;
  gap: 12px;
  @media ${({ theme }: PalletteProps) => theme.breakpoints.mobileL} {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
`;

export const ThumbnailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  @media ${({ theme }: PalletteProps) => theme.breakpoints.mobileL} {
    flex-direction: column;
    gap: 19px;
  }
`;

export const Thumbnail = styled.figure`
  width: 105px;
  height: 105px;
  background-color: ${({ theme }: PalletteProps) => theme.white};
  position: relative;
  box-shadow: 0px 0px 50px rgba(200, 200, 200, 0.2);
  border: 1px solid rgba(200, 200, 200, 0.1);
  &:hover {
    cursor: pointer;
    box-shadow: 0px 0px 50px rgba(200, 200, 200, 0.4);
    transition: ease-in-out 200ms;  
  }
  @media ${({ theme }: PalletteProps) => theme.breakpoints.mobileL} {
    width: 146px;
    height: 146px;
  }
`;

export const Photo = styled.figure`
  width: 344px;
  height: 344px;
  position: relative;
  background-color: ${({ theme }: PalletteProps) => theme.white};
  box-shadow: 0px 0px 50px rgba(200, 200, 200, 0.2);
  border: 1px solid rgba(200, 200, 200, 0.1);
  &:hover {
    box-shadow: 0px 0px 50px rgba(200, 200, 200, 0.4);
    transition: ease-in-out 200ms;
  }
  @media ${({ theme }: PalletteProps) => theme.breakpoints.mobileL} {
    width: 476px;
    height: 476px;
  }
`;
